import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted } from 'vue';
    import MainNavigation from '@/ComponentsChild/MainNavigation.vue';
    // eslint-disable-next-line
    import { useAuth0, Auth0Symbol } from '@/Services/Auth0/auth0-plugin';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

    const auth0 = useAuth0()

    onMounted(async() => {
        if (!auth0) {
            console.log('auth0 on app.vue has no value')
            return;
        }
        console.log('app.vue createClient')
        await auth0.createClient();
        await auth0.handleCallback();
        
    })       

//export default defineComponent({
//  name: 'App',
//  components: {
//    MainNavigation
//  }
//});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(MainNavigation),
        _createVNode(_component_v_main, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_container, null, {
              default: _withCtx(() => [
                _createVNode(_component_router_view)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})